module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "quoteSummary"
  }, [(_vm.totalPending) ? _c('center', [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  })]) : _c('v-form', [_c('v-layout', {
    staticStyle: {
      "padding-right": "200px !important"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel pr-2"
  }, [_vm._v("CURRENT FILTERS:")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "display": "inline",
      "margin-top": "1px",
      "height": "33px",
      "font-size": "9px !important",
      "width": "5px"
    },
    attrs: {
      "small": "",
      "color": "info"
    },
    on: {
      "click": _vm.fncOpenFilters
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_alt")]), _vm._v("Filters")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "display": "block",
      "float": "right",
      "margin-top": "1px",
      "height": "39px"
    },
    attrs: {
      "small": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncGenerateStatusSummaryReport()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("summarize")]), _vm._v("Download Summary")])], 1), _vm._v(" "), (_vm.isReportSearch) ? [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel ",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("Date:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.quote_start_date) + " to " + _vm._s(_vm.quote_end_date))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel ",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("Report Search:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.reportSearch))])])] : _vm._l((_vm.topTabsCount.filters), function(value, index) {
    return [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('label', {
      staticClass: "blackLabel ",
      staticStyle: {
        "font-weight": "500"
      }
    }, [_vm._v(_vm._s(index) + ":")])]), _vm._v(" "), (value.length > 0) ? _c('v-flex', {
      attrs: {
        "xs10": ""
      }
    }, [_c('span', [_vm._v(_vm._s(value[0]))])]) : _c('v-flex', {
      attrs: {
        "xs11": ""
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.topTabsCount.filters[index]))])])]
  }), _vm._v(" "), (Object.keys(_vm.tabs['is_initial_engagement_quote']).length > 0) ? [_c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel  ",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px"
    }
  }, [_vm._v("Initial Engagement and Quoting")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayTopTabCount('is_initial_engagement_quote'))
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayTopTabValue('is_initial_engagement_quote'))
    }
  })]), _vm._v(" "), _vm._l((_vm.tabs['is_initial_engagement_quote']), function(value, index) {
    return (_vm.fncHideZero('is_initial_engagement_quote', value.description)) ? [_c('v-flex', {
      staticClass: "pl-3",
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("\n          " + _vm._s(value.description) + "\n        ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('span', {
      staticClass: "floatRight",
      domProps: {
        "innerHTML": _vm._s(_vm.fncDisplayBottomTabCount('is_initial_engagement_quote', value.description))
      }
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('span', {
      staticClass: "floatRight",
      domProps: {
        "innerHTML": _vm._s(_vm.fncDisplayBottomTabValue('is_initial_engagement_quote', value.description))
      }
    })])] : _vm._e()
  })] : _vm._e(), _vm._v(" "), (Object.keys(_vm.tabs['is_negotiating_customer_approval']).length > 0) ? [_c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel ",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px"
    }
  }, [_vm._v("Negotiation Customer Approval")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayTopTabCount('is_negotiating_customer_approval'))
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayTopTabValue('is_negotiating_customer_approval'))
    }
  })]), _vm._v(" "), _vm._l((_vm.tabs['is_negotiating_customer_approval']), function(value, index) {
    return (_vm.fncHideZero('is_negotiating_customer_approval', value.description)) ? [_c('v-flex', {
      staticClass: "pl-3",
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("\n          " + _vm._s(value.description) + "\n        ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('span', {
      staticClass: "floatRight",
      domProps: {
        "innerHTML": _vm._s(_vm.fncDisplayBottomTabCount('is_negotiating_customer_approval', value.description))
      }
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('span', {
      staticClass: "floatRight",
      domProps: {
        "innerHTML": _vm._s(_vm.fncDisplayBottomTabValue('is_negotiating_customer_approval', value.description))
      }
    })])] : _vm._e()
  })] : _vm._e(), _vm._v(" "), (Object.keys(_vm.tabs['is_manufacturer_fulfilment']).length > 0) ? [_c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel ",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px"
    }
  }, [_vm._v("Manufacture & Fulfilment")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayTopTabCount('is_manufacturer_fulfilment'))
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayTopTabValue('is_manufacturer_fulfilment'))
    }
  })]), _vm._v(" "), _vm._l((_vm.tabs['is_manufacturer_fulfilment']), function(value, index) {
    return (_vm.fncHideZero('is_manufacturer_fulfilment', value.description)) ? [_c('v-flex', {
      staticClass: "pl-3",
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("\n          " + _vm._s(value.description) + "\n        ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('span', {
      staticClass: "floatRight",
      domProps: {
        "innerHTML": _vm._s(_vm.fncDisplayBottomTabCount('is_manufacturer_fulfilment', value.description))
      }
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('span', {
      staticClass: "floatRight",
      domProps: {
        "innerHTML": _vm._s(_vm.fncDisplayBottomTabValue('is_manufacturer_fulfilment', value.description))
      }
    })])] : _vm._e()
  })] : _vm._e(), _vm._v(" "), (Object.keys(_vm.tabs['is_cancelled_expired_rejected']).length > 0) ? [_c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel ",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px"
    }
  }, [_vm._v("Cancelled, Expired or Rejected")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayTopTabCount('is_cancelled_expired_rejected'))
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "30px !important"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayTopTabValue('is_cancelled_expired_rejected'))
    }
  })]), _vm._v(" "), _vm._l((_vm.tabs['is_cancelled_expired_rejected']), function(value, index) {
    return (_vm.fncHideZero('is_cancelled_expired_rejected', value.description)) ? [_c('v-flex', {
      staticClass: "pl-3",
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("\n          " + _vm._s(value.description) + "\n        ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('span', {
      staticClass: "floatRight",
      domProps: {
        "innerHTML": _vm._s(_vm.fncDisplayBottomTabCount('is_cancelled_expired_rejected', value.description))
      }
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('span', {
      staticClass: "floatRight",
      domProps: {
        "innerHTML": _vm._s(_vm.fncDisplayBottomTabValue('is_cancelled_expired_rejected', value.description))
      }
    })])] : _vm._e()
  })] : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "35px !important",
      "border-radius": "5px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel ",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px"
    }
  }, [_vm._v("TOTAL QUOTES")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    }
  }, [_vm._v(_vm._s(_vm.topTabsCount.quote_total_count))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel floatRight",
    staticStyle: {
      "font-weight": "500",
      "font-size": "16px",
      "text-align": "right !important"
    }
  }, [_vm._v("R" + _vm._s(_vm.topTabsCount.quote_sum_total))])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-2 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)
},staticRenderFns: []}